import { render, staticRenderFns } from "./WagesTableCard.vue?vue&type=template&id=10c7d056&scoped=true"
import script from "./WagesTableCard.vue?vue&type=script&lang=ts"
export * from "./WagesTableCard.vue?vue&type=script&lang=ts"
import style0 from "./WagesTableCard.vue?vue&type=style&index=0&id=10c7d056&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c7d056",
  null
  
)

export default component.exports